/**
 * Learn more about theme events at
 * https://help.switchthemes.co/baseline/developer/theme-events/overview.html
 */

window.theme = window.theme || {};

window.theme.events = {
  version: '1.1',
};

document.addEventListener('theme:update:cart', async () => {
  document.dispatchEvent(new CustomEvent('baseline:cart:lock'));

  try {
    const response = await fetch(
      `${window.location.pathname}?sections=cart-items,cart-footer,cart-item-count,cart-live-region`
    );
    const data = await response.json();

    if (!data.status) {
      document.body.dispatchEvent(
        new CustomEvent('baseline:cart:update', {
          bubbles: true,
          detail: {
            response: {
              sections: {
                ...data,
              },
            },
          },
        })
      );
    }
  } catch (e) {
    console.error(e);
    document.getElementById('cart-errors').textContent =
      theme.strings.cartError;
    document.dispatchEvent(
      new CustomEvent('theme:cart:error:other', {
        detail: {
          message: theme.strings.cartError,
          error: e,
        },
      })
    );
  } finally {
    document.dispatchEvent(new CustomEvent('baseline:cart:unlock'));
  }
});

const getCartDrawerEl = () => {
  return document.querySelector('[data-cart-drawer]');
};

document.body.addEventListener('cart-will-open', async () => {
  document.dispatchEvent(
    new CustomEvent('theme:cart-drawer:opening', {
      detail: {
        cartDrawerEl: getCartDrawerEl(),
      },
    })
  );
});

document.body.addEventListener('cart-is-open', async () => {
  document.dispatchEvent(
    new CustomEvent('theme:cart-drawer:open', {
      detail: {
        cartDrawerEl: getCartDrawerEl(),
      },
    })
  );
});

document.body.addEventListener('cart-will-close', () => {
  document.dispatchEvent(
    new CustomEvent('theme:cart-drawer:closing', {
      detail: {
        cartDrawerEl: getCartDrawerEl(),
      },
    })
  );
});

document.body.addEventListener('cart-is-closed', () => {
  document.dispatchEvent(
    new CustomEvent('theme:cart-drawer:closed', {
      detail: {
        cartDrawerEl: getCartDrawerEl(),
      },
    })
  );
});

document.addEventListener('theme:open:cart-drawer', () => {
  if (
    window.theme.settings.cartType === 'drawer' &&
    Alpine.store('modals').modals.cart
  ) {
    Alpine.store('modals').closeAll();

    Alpine.store('modals').open('cart');
  }
});

document.addEventListener('theme:close:cart-drawer', () => {
  if (
    window.theme.settings.cartType === 'drawer' &&
    Alpine.store('modals').modals.cart
  ) {
    Alpine.store('modals').close('cart');
  }
});

const cartChangeEventHandler = (e) => {
  const { cartItemCount, itemsRootEl, lineItemEl, variantId, key } = e.detail;

  document.dispatchEvent(
    new CustomEvent('theme:cart:change', {
      detail: {
        type: e.type,
        cartItemCount,
        itemsRootEl,
        lineItemEl,
        variantId,
        key,
        originalDetail: e.detail,
      },
    })
  );
};

document.addEventListener('theme:product:add', cartChangeEventHandler);
document.addEventListener('theme:line-item:change', cartChangeEventHandler);

const cartErrorEventHandler = (e) => {
  document.dispatchEvent(
    new CustomEvent('theme:cart:error', {
      detail: {
        type: e.type,
        message: e.detail.message,
        originalDetail: e.detail,
      },
    })
  );
};

document.addEventListener(
  'theme:product:error:add-to-cart',
  cartErrorEventHandler
);

document.addEventListener('theme:line-item:error', cartErrorEventHandler);
document.addEventListener('theme:cart:error:other', cartErrorEventHandler);

/**
 * Set `window.themeEventsDebugMode` to `true` to log events
 * outside the theme editor
 */

if (Shopify.designMode || window.themeEventsDebugMode) {
  const themeEvents = [
    'theme:variant:change',
    'theme:product:add',
    'theme:line-item:change',
    'theme:cart:change',
    'theme:cart:update',
    'theme:cart-drawer:opening',
    'theme:cart-drawer:open',
    'theme:cart-drawer:closing',
    'theme:cart-drawer:closed',
    'theme:product:error:add-to-cart',
    'theme:line-item:error',
    'theme:cart:error:other',
    'theme:cart:error',
  ];

  const aggregateEvents = ['theme:cart:change', 'theme:cart:error'];

  for (const eventName of themeEvents) {
    let color;

    if (eventName.includes('error')) {
      color = '#ef4444';
    } else {
      color = '#22c55e';
    }

    const message = [
      `%c\u25CF %c${eventName}`,
      `color: ${color};`,
      'font-weight: bold;',
    ];

    if (aggregateEvents.includes(eventName)) {
      document.addEventListener(eventName, (e) => {
        console.groupCollapsed(...message);
        console.log(
          `Underlying event: %c${e.detail.type}`,
          'font-weight: bold;'
        );
        console.log('Event detail:', e.detail);
        console.groupEnd();
      });
    } else {
      document.addEventListener(eventName, (e) => {
        console.log(...message, e.detail);
      });
    }
  }
}

// Navigation hover functionality
document.addEventListener('DOMContentLoaded', function() {
  const navItems = document.querySelectorAll('.no-js-focus-wrapper');
  const hoverDelay = 250;
  let hoverTimeout;

  function isDesktop() {
    return window.matchMedia('(min-width: 990px)').matches;
  }

  navItems.forEach(item => {
    const button = item.querySelector('button');
    const dropdown = item.querySelector('[id^="menu"]');

    if (!button || !dropdown) return;

    // Hover to open
    item.addEventListener('mouseenter', function() {
      if (!isDesktop()) return;

      clearTimeout(hoverTimeout);
      hoverTimeout = setTimeout(() => {
        const alpineData = Alpine.$data(item);
        if (alpineData && !alpineData.expanded) {
          button.click();
        }
      }, hoverDelay);
    });

    // Keep open when hovering the dropdown
    dropdown.addEventListener('mouseenter', function() {
      if (!isDesktop()) return;
      clearTimeout(hoverTimeout);
    });

    // Close when leaving the nav item
    item.addEventListener('mouseleave', function(e) {
      if (!isDesktop()) return;

      // Don't close if moving to the dropdown
      if (dropdown.contains(e.relatedTarget)) return;

      clearTimeout(hoverTimeout);
      hoverTimeout = setTimeout(() => {
        const alpineData = Alpine.$data(item);
        if (alpineData && alpineData.expanded) {
          button.click();
        }
      }, 100);
    });

    // Close when leaving the dropdown
    dropdown.addEventListener('mouseleave', function(e) {
      if (!isDesktop()) return;

      // Don't close if moving back to the nav item
      if (item.contains(e.relatedTarget)) return;

      clearTimeout(hoverTimeout);
      const alpineData = Alpine.$data(item);
      if (alpineData && alpineData.expanded) {
        button.click();
      }
    });
  });

});

// Inject recently viewed products into predictive search no-results state
(function () {
  function renderPredictiveRecentlyViewed(container) {
    const rvSection = container.querySelector('[data-predictive-rv]');
    const grid = container.querySelector('[data-predictive-rv-grid]');
    if (!rvSection || !grid) return;

    let recent = [];
    try {
      recent = JSON.parse(localStorage.getItem('acRecentlyViewed') || '[]');
    } catch { return; }
    if (!Array.isArray(recent) || recent.length === 0) return;

    const items = recent.slice(0, 4);
    grid.innerHTML = items.map(p => `
      <li>
        <a href="${p.url}" class="block group">
          <div class="aspect-square overflow-hidden bg-scheme-background mb-2">
            <img
              src="${p.image}"
              alt="${p.title.replace(/"/g, '&quot;')}"
              class="w-full h-full object-cover group-hover:opacity-80 transition-opacity duration-200"
              loading="lazy"
            >
          </div>
          <p class="text-xs font-heading leading-snug mb-0.5">${p.title}</p>
          <p class="text-xs opacity-60">${p.price}</p>
        </a>
      </li>
    `).join('');

    rvSection.classList.remove('hidden');
  }

  const observer = new MutationObserver(() => {
    const noResults = document.querySelector('[data-predictive-no-results]');
    if (noResults) renderPredictiveRecentlyViewed(noResults);
  });

  document.addEventListener('DOMContentLoaded', () => {
    const resultsEl = document.getElementById('predictive-search-results');
    if (resultsEl) {
      observer.observe(resultsEl, { childList: true, subtree: true });
    }
  });
})();

// Arc underline on top-level nav items
(function () {
  if (document.getElementById('ac-wobbly-underline-styles')) return;

  const style = document.createElement('style');
  style.id = 'ac-wobbly-underline-styles';
  style.textContent = `
    .ac-wobbly-span {
      position: relative;
      display: inline-block;
    }

    .ac-wobbly-svg {
      position: absolute;
      bottom: -8px;
      left: 0;
      width: 100%;
      height: 8px;
      pointer-events: none;
      overflow: visible;
    }

    /* Override any border-bottom or text-decoration the theme applies to nav links */
    header .ac-wobbly-target {
      text-decoration: none !important;
      border-bottom: none !important;
    }

    .ac-wobbly-svg path {
      stroke-dasharray: 1;
      stroke-dashoffset: 1;
      opacity: 0;
      transition: stroke-dashoffset 0.5s cubic-bezier(0.25, 0, 0.1, 1), opacity 0.15s ease;
    }

    .no-js-focus-wrapper:hover .ac-wobbly-svg path,
    button[aria-expanded="true"] .ac-wobbly-svg path,
    button[data-active="true"] .ac-wobbly-svg path,
    .ac-wobbly-target:hover .ac-wobbly-svg path,
    .ac-wobbly-target:focus-visible .ac-wobbly-svg path {
      stroke-dashoffset: 0;
      opacity: 1;
    }

    .ac-wobbly-target[aria-current="page"] .ac-wobbly-svg path,
    button[data-active="true"] .ac-wobbly-svg path {
      stroke-dashoffset: 0;
      opacity: 1;
      transition: none;
    }

    @media (prefers-reduced-motion: reduce) {
      .ac-wobbly-svg path { transition: opacity 0.15s ease; }
    }
  `;
  document.head.appendChild(style);

  function buildSvg() {
    const ns = 'http://www.w3.org/2000/svg';
    const svg = document.createElementNS(ns, 'svg');
    svg.setAttribute('class', 'ac-wobbly-svg');
    svg.setAttribute('aria-hidden', 'true');
    svg.setAttribute('viewBox', '0 0 100 10');
    svg.setAttribute('preserveAspectRatio', 'none');
    const path = document.createElementNS(ns, 'path');
    path.setAttribute('d', 'M0,2 Q50,9 100,2');
    path.setAttribute('pathLength', '1');
    path.setAttribute('stroke', 'currentColor');
    path.setAttribute('stroke-width', '1.5');
    path.setAttribute('fill', 'none');
    path.setAttribute('stroke-linecap', 'round');
    svg.appendChild(path);
    return svg;
  }

  function addWobblyUnderline(el) {
    const textSpan = el.querySelector('span:not([aria-hidden]):not(.rotate):not([x-show]):not(.sr-only)');
    const target = textSpan || el;
    if (target.querySelector('.ac-wobbly-svg')) return;
    target.classList.add('ac-wobbly-span');
    target.appendChild(buildSvg());
  }

  function initWobblyUnderlines() {
    // Dropdown trigger buttons
    document.querySelectorAll('.no-js-focus-wrapper button').forEach(addWobblyUnderline);

    // Plain top-level nav links (not inside dropdowns, not the logo)
    document.querySelectorAll('header nav a').forEach(function (link) {
      if (link.closest('.no-js-focus-container')) return;
      if (link.closest('.no-js-focus-wrapper')) return;
      if (link.closest('.whitespace-nowrap')) return; // skip search, cart, account utility links
      if (link.querySelector('img, div')) return; // skip logo
      link.classList.add('ac-wobbly-target');
      addWobblyUnderline(link);
    });

    // Mark parent button as active when a child link is the current page
    document.querySelectorAll('.no-js-focus-wrapper').forEach(function (wrapper) {
      if (wrapper.querySelector('.no-js-focus-container a[aria-current="page"]')) {
        var btn = wrapper.querySelector('button');
        if (btn) btn.setAttribute('data-active', 'true');
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initWobblyUnderlines);
  } else {
    initWobblyUnderlines();
  }
})();
